import FilterItem from '../FilterItem';
import FilterListStorage from './FilterListStorage';
import { collectFeatureValue, featureOptionsToItems } from './featureValues';

class FilterAutocomplete extends FilterItem {
  valuesStorage = null;

  constructor(conf, subcategory) {
    super(conf, subcategory);
    this.valuesStorage = new FilterListStorage();
  }

  setValuesList(valuesList) {
    this.valuesStorage.setValuesList(valuesList);
  }

  collectValues() {
    if (this.isFeature) {
      return {
        __feature: collectFeatureValue({
          featureID: this.featureID,
          value: this.value,
          strategy: this.strategy,
          isNA: this.isNA,
        }),
      };
    }
    return super.collectValues();
  }

  async apply(values) {
    if (this.isFeature) {
      this.valuesStorage.setValuesList(featureOptionsToItems(this.options.valuesList));
      this.value = this.valuesStorage.filterAvailableValues(values);
      this.resetLoadersContext();
      return;
    }
    if (values.length === 1 && values[0] === false) {
      this.na = true;
      return;
    }
    this.loadersContext = {
      ...this.loadersContext,
      itemsKey: 'id',
      itemsToLoad: values[0],
    };

    const fieldConf = this.fieldConf || {};
    let items = [];

    if (typeof fieldConf.searcher === 'function') {
      if (this.id === 'authors.id' || this.id === 'domain_id') {
        items = await fieldConf.searcher('', values[0]);
      } else if (
        this.id === 'created.id' ||
        this.id === 'brands' ||
        this.id === 'tradeBrands.id' ||
        this.id === 'holders.holderName.id' ||
        this.id === 'manufacturedProducts.brands.id' ||
        this.id === 'parent' ||
        this.id === 'prompt_id' ||
        this.id === 'customer.id' ||
        this.id === 'project.id'
      ) {
        items = await fieldConf.searcher('', { id: values[0] });
      } else if (this.id === 'registrationOffice.code') {
        items = await fieldConf.searcher('', { code: values[0] });
      } else {
        items = await fieldConf.searcher();
      }
    } else if (typeof fieldConf.items === 'function') {
      items = await fieldConf.items();
    }

    this.valuesStorage.setValuesList(items || []);
    this.value = this.valuesStorage.normalizeValues(values[0]);
    this.resetLoadersContext();
  }

  resetValue = () => {
    this.value = [];
  };

  get valuesList() {
    return this.valuesStorage.valuesList;
  }

  getValueLabel = (id) => {
    return this.valuesStorage.getValueLabel(id);
  };

  removeValueFromList(id) {
    this.value = this.value.filter((item) => item != id);
  }
}

export default FilterAutocomplete;
